import { createSlice } from "@reduxjs/toolkit";

export const uiSlice = createSlice({
  name: "ui",
  initialState: {
    tab: "Calculator",
    introOn: true,
    settingsOn: false,
    stdSetupI: 0,
    cmpSetupIs: [0],
    importType: 0,
    importInfo: null
  },
  reducers: {
    CHANGE_TAB: (state, action) => {
      state.tab = action.payload;
    },
    TOGGLE_INTRO: (state, action) => {
      state.introOn = action.payload;
    },
    RESET_CALC_UI: (state) => {
      state.tab = "Calculator";
      state.stdSetupI = 0;
      state.cmpSetupIs = [0];
      state.settingsOn = false;
    },
    CHANGE_STD_SETUP: (state, action) => {
      const newIndex = action.payload;
      const { cmpSetupIs } = state;
      if (cmpSetupIs.length === 1) {
        cmpSetupIs[0] = newIndex;
      } else {
        const i = cmpSetupIs.indexOf(newIndex);
        if (i === -1) {
          cmpSetupIs.unshift(newIndex);
        } else if (i > 0) {
          [cmpSetupIs[0], cmpSetupIs[i]] = [cmpSetupIs[i], cmpSetupIs[0]];
        }
      }
      state.stdSetupI = newIndex;
    },
    OPEN_SETTINGS: (state) => {
      state.settingsOn = true;
    },
    CLOSE_SETTINGS: (state) => {
      state.settingsOn = false;
    },
    APPLY_SETTINGS_UI: (state, action) => {
      const { cmpSetupIs, standardI } = action.payload;
      state.cmpSetupIs = cmpSetupIs;
      state.stdSetupI = standardI;
      state.settingsOn = false;
    },
    START_IMPORT: (state, action) => {
      const { importInfo, type } = action.payload;
      state.importType = type;
      state.importInfo = importInfo;
    },
    END_IMPORT: (state) => {
      state.importInfo = null;
      state.importType = 0;
    },
    TO_IMPORTED: (state) => {
      state.tab = "Calculator";
      state.settingsOn = false;
    }
  }
});

export const {
  CHANGE_TAB,
  TOGGLE_INTRO,
  RESET_CALC_UI,
  CHANGE_STD_SETUP,
  OPEN_SETTINGS,
  CLOSE_SETTINGS,
  APPLY_SETTINGS_UI,
  START_IMPORT,
  TO_IMPORTED,
  END_IMPORT
} = uiSlice.actions;

export const selectTab = (state) => state.ui.tab;

export const selectStdSetupI = (state) => state.ui.stdSetupI;

export const selectCmpSetupIs = (state) => state.ui.cmpSetupIs;

export default uiSlice.reducer;
